const monthNames = new Map<number, string>([
  [1, 'Jan'],
  [2, 'Feb'],
  [3, 'Mar'],
  [4, 'Apr'],
  [5, 'May'],
  [6, 'Jun'],
  [7, 'Jul'],
  [8, 'Aug'],
  [9, 'Sep'],
  [10, 'Oct'],
  [11, 'Nov'],
  [12, 'Dec'],
]);

export const formatDate = (date: string | Date | undefined | null): string => {
  if (!date) return 'N/A';

  if (date instanceof Date) {
    const d = date;
    const year = d.getFullYear();
    const month = monthNames.get(d.getMonth() + 1);
    const day = d.getDate();
    return `${month} ${day}, ${year}`;
  }

  try {
    const dateSplit = date.split('-');
    if (dateSplit.length < 3) return date;
    return `${monthNames.get(Number(dateSplit[1]))} ${Number(dateSplit[2])} ${dateSplit[0]}`;
  } catch (e) {
    return 'N/A';
  }
};

export const formatRelativeTime = (timestamp: number): string => {
  const now = Date.now();
  const diff = now - timestamp;
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) return 'Just now';
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 7) return `${days}d ago`;
  
  return formatDate(new Date(timestamp));
};
